import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';


export default class CourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            courseList: [],

            admin: !!localStorage.getItem('activeRole').includes('QA admin:'),
            orgUnitId: JSON.parse(localStorage.getItem('organizationalUnitId')),
            pollId: JSON.parse(localStorage.getItem('poll')).pollId,

        };
    }
    componentDidMount() {
        localStorage.removeItem('defIndex');
        localStorage.removeItem('courseId');
        localStorage.removeItem('courseName');
        localStorage.removeItem('numberOfStudentsWhoRatedCourse');
        localStorage.removeItem('numberOfStudentsWhoRatedEmployee');
        let obj = {
            id: parseInt(localStorage.getItem('organizationalUnitEmployeeId'), 10)
        };
        axios.post(`/questionnaire/staff-results/course-implementations/${this.state.pollId}/`, { ...obj })
            .then(res => {
                const courseList = res.data;
                this.setState({ courseList, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.courseList;
    }

    fixTwoDecimals(value) {
        const num = Number(value);

        if (!Number.isFinite(num) || num === -1) {
            return '-';
        }

        return num.toFixed(2);
    }

    render() {
        return (
            <div>
                <Header as="h1">
                    Ankete
                </Header>
                <Segment.Group clearing raised >
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                Predmeti
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('staffName')) === 'null' ? ' ' : localStorage.getItem('staffName')}
                            </Header.Subheader>
                        </Header>
                    </Segment>

                    <Segment>
                        { this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> : <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row >
                                    <Table.HeaderCell colSpan="2">
                                        Naziv predmeta
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        Grupa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        Broj studenata na predmetu
                                    </Table.HeaderCell>

                                    <Table.HeaderCell >
                                        Broj studenata koji su ocijenili predmet
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        Broj studenata koji su ocijenili nastavnika
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        Prosječna ocjena za sekciju predmet
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        Prosječna ocjena za sekciju nastavnik
                                    </Table.HeaderCell>

                                    <Table.HeaderCell textAlign="center" >Rezultati</Table.HeaderCell>


                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.getDataToRender().map((el, index) =>
                                    el.numberOfStudentsOnCourse === -1 ?
                                        (<Table.Row
                                            key={index}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                    localStorage.setItem('courseId', el.courseImplementationId);
                                                    localStorage.setItem('courseName', el.courseImplementationName);
                                                    localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                    localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                    localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                    localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse);
                                                    localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                    this.setState({ showResults: true });
                                                }
                                            }}
                                        >
                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                <Grid columns={1} centered className="stackable">
                                                    <Grid.Row verticalAlign="middle">
                                                        <Grid.Column width="10">
                                                            <span>{el.courseImplementationName ? el.courseImplementationName : '/'}</span>
                                                        </Grid.Column>
                                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                            <span style={{ color: '#a6a4a1' }}>{el.courseBasicComment}</span>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={5} textAlign="center">
                                                Implementacija predmeta je kreirana nakon početka anketiranja.
                                            </Table.Cell>
                                        </Table.Row>)
                                        :
                                        (<Table.Row
                                            key={index}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                    localStorage.setItem('courseId', el.courseImplementationId);
                                                    localStorage.setItem('courseName', el.courseImplementationName);
                                                    localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                    localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                    localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                    localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse);
                                                    localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                    this.setState({ showResults: true });
                                                }
                                            }}
                                        >
                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                <Grid columns={1} centered className="stackable">
                                                    <Grid.Row verticalAlign="middle">
                                                        <Grid.Column width="10">
                                                            <span>{el.courseImplementationName ? el.courseImplementationName : '/'}</span>
                                                        </Grid.Column>
                                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                            <span style={{ color: '#a6a4a1' }}>{el.courseBasicComment}</span>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.groupName ? el.groupName : '-'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudentsOnCourse ? el.numberOfStudentsOnCourse : '0'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudentsWhoRatedCourse ? el.numberOfStudentsWhoRatedCourse : '0'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudentsWhoRatedEmployee ? el.numberOfStudentsWhoRatedEmployee : '0'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {this.fixTwoDecimals(el.averageGradeCourse)}
                                                {/* {(el.averageGradeCourse && el.averageGradeCourse !== -1) ? el.averageGradeCourse : '-'} */}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {this.fixTwoDecimals(el.averageGradeStaff)}
                                                {/* {(el.averageGradeStaff && el.averageGradeStaff !== -1) ? el.averageGradeStaff : '-'} */}
                                            </Table.Cell>

                                            <Table.Cell verticalAlign="middle" textAlign="center">
                                                {/* link */}

                                                <Button
                                                    onClick={() => {
                                                        localStorage.setItem('courseId', el.courseImplementationId);
                                                        localStorage.setItem('courseName', el.courseImplementationName);
                                                        localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                        localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                        localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                        localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse);
                                                        localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                    }}
                                                    disabled={!el.numberOfStudentsWhoRatedCourse && !el.numberOfStudentsWhoRatedEmployee}
                                                    basic="true"
                                                    color="blue"
                                                    size="small"
                                                >
                                                    <Link to={{
                                                        pathname: this.state.admin ? '/rezultati/osoblje/predmeti/pregled' : '/ankete/osoblje/predmeti/rezultati',
                                                    }}
                                                    >
                                                        Tabelarni prikaz
                                                    </Link>
                                                </Button>

                                                {/* <Link to={{ */}
                                                {/*    pathname: '/ankete/osoblje/predmeti/grafički-prikaz', */}

                                                {/* }} */}
                                                {/* > */}
                                                {/* <Button */}
                                                {/*    onClick={() => { */}
                                                {/*        localStorage.setItem('courseId', el.courseImplementationId); */}
                                                {/*        localStorage.setItem('courseName', el.courseImplementationName); */}
                                                {/*        localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse); */}
                                                {/*        localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee); */}
                                                {/*    }} */}
                                                {/*    disabled={!el.numberOfStudentsWhoRatedCourse && !el.numberOfStudentsWhoRatedEmployee} */}
                                                {/*    basic="true" */}
                                                {/*    color="green" */}
                                                {/*    size="small" */}
                                                {/* >  Grafički prikaz */}

                                                {/* </Button> */}
                                                {/* </Link> */}

                                            </Table.Cell>
                                        </Table.Row>))}
                            </Table.Body>

                        </Table>}
                    </Segment>


                </Segment.Group>
            </div>


        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/CourseList.js